/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IgnoredTombstoneOrHideContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly " $refType": "IgnoredTombstoneOrHideContainer_comment";
};
export type IgnoredTombstoneOrHideContainer_comment$data = IgnoredTombstoneOrHideContainer_comment;
export type IgnoredTombstoneOrHideContainer_comment$key = {
    readonly " $data"?: IgnoredTombstoneOrHideContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"IgnoredTombstoneOrHideContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "IgnoredTombstoneOrHideContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '8c2273fef66cfb53268e02d678f09bf9';
export default node;
